/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

import { SubscriptionAudit } from "App/IOC/Services";

export default {
    FindBySubscription: SubscriptionAudit.FindBySubscription,
    FindByCustomer: SubscriptionAudit.FindByCustomer
};
